import React from 'react';
import {Route, IndexRoute} from 'react-router';
import Loadable from 'react-loadable';
import config from  '../../config';
import AppLayout from 'common/AppLayout';

import APIDocumentation from 'common/APIDocumentation';
import StaticPageContainer from 'common/StaticPageContainer';

import   Dashboard from 'dashboard/Dashboard';
import  AdminPanel from 'dashboard/AdminPanel';
 import  PartnerPanel from 'partners/PartnerPanel';

import   ResetPassword from 'common/ResetPassword';
import   Login from 'common/Login';


/* Admin */

import   AdminProductsPage from 'dashboard/products/AdminProductsPage';
import   AdminProductEdit from 'dashboard/products/AdminProductEdit';
import   AdminUserAddEdit from 'dashboard/users/AdminUserAddEdit';
import   AdminMetroAreaAddEdit from 'dashboard/metroAreas/AdminMetroAreaAddEdit';
import AdminContractorsPage  from 'dashboard/contractors/AdminContractorsPage';
import   AdminProductDetails from 'dashboard/products/AdminProductDetails';
import   AdminSellerAddEdit from 'dashboard/sellers/AdminSellerAddEdit';
import   AmazonSearch  from 'dashboard/products/AmazonSearch';




/* Client */

// const AsyncProductDetailPage = Loadable({
//     loader: () => import(/* webpackChunkName: "dashboard" */'dashboard/products/AdminProductDetail.js'),
//     loading: () => null
// });

if (config.getEnvironmentName() == 'local') {
    var clientRoutes = require('routes/clientRoutes').default();
}

import NotFound from 'common/NotFound';
console.log('getEnvironmentName', config.getEnvironmentName());
export default (
    <div>
        <Route path="api_documentation" component={APIDocumentation}/>
        <Route path="static/:pageName"  component={StaticPageContainer}/>
         <Route path="/" component={AppLayout}>
            <Route path="login" component={Login}/>
            <Route path="reset-password" component={ResetPassword}/>
             <Route path="partner" component={ Dashboard}>
                 <IndexRoute component={ PartnerPanel }/>
                 <Route path="products" component={ PartnerPanel }/>
                 <Route path="transactions" component={ PartnerPanel }/>
             </Route>
            {config.getEnvironmentName() == 'local' ? clientRoutes : null}
            <Route path="admin" component={ Dashboard}>
                <IndexRoute component={ AdminPanel }/>
                <Route path="products" component={ AdminPanel }/>
                <Route path="sellers/:id/products" component={  AdminProductsPage }/>
                <Route path="seller/:id/edit" component={  AdminSellerAddEdit }/>
                <Route path="sellers" component={ AdminPanel }/>
                <Route path="contractors" component={ AdminPanel }/>
                <Route path="users" component={  AdminPanel }/>
                <Route path="focus-areas" component={  AdminPanel }/>
                <Route path="categories" component={  AdminPanel }/>
                <Route path="gbg-products" component={  AdminPanel }/>
                <Route path="subscriptions" component={  AdminPanel }/>
                <Route path="services" component={  AdminPanel }/>
                <Route path="services/add" component={  AdminPanel }/>
                <Route path="service-areas" component={  AdminPanel }/>
                <Route path="metro-area/add" component={  AdminMetroAreaAddEdit }/>
                <Route path="metro-area/:id/edit" component={ AdminMetroAreaAddEdit }/>
                <Route path="metro-areas" component={  AdminPanel }/>
                <Route path="time-tracking" component={ AdminPanel }/>
                <Route path="time-tracking-registry" component={ AdminPanel }/>
                <Route path="orders" component={ AdminPanel }/>
                <Route path="pallets" component={ AdminPanel }/>
                <Route path="reports" component={ AdminPanel }/>
                <Route path="kpi_reports" component={ AdminPanel }/>

                <Route path="emails" component={  AdminPanel }/>
                <Route path="promo-codes" component={  AdminPanel }/>
                {/*<Route path="payout-registry/add-fee" component={ AdminTransactionAddEdit}/>*/}
                {/*<Route path="payout-registry/:sellerID/add-fee" component={ AdminTransactionAddEdit}/>*/}

                <Route path="payout-registry" component={  AdminPanel }/>

                {/*<Route path="sellers" component={ AdminSellerList } />*/}
                <Route path="seller/:userID/add" component={  AdminSellerAddEdit }/>
                <Route path="contractors/:userID/add" component={  AdminContractorsPage }/>
                <Route path="user/add" component={  AdminUserAddEdit }/>
                <Route path="user/:id/edit" component={  AdminUserAddEdit }/>
                <Route path="product/:product_id/edit" component={  AdminProductEdit }/>
                <Route path="product/:product_id/details" component={  AdminProductDetails }/>
                <Route path="products-test" component={  AmazonSearch }/>
                <Route path="settings" component={  AdminPanel }/>
                <Route path="quality-checks" component={  AdminPanel }/>
                <Route path="fulfillment" component={  AdminPanel }/>
                <Route path="inventory-recon" component={  AdminPanel }/>
                <Route path="inventory-projects" component={  AdminPanel }/>
                <Route path="processing" component={  AdminPanel }/>
                <Route path="posting" component={  AdminPanel }/>
                <Route path="processing-3PL" component={  AdminPanel }/>
                <Route path="inboundRebound" component={  AdminPanel }/>
                <Route path="processing-seller" component={  AdminPanel }/>
                <Route path="processing-3PL-manager" component={  AdminPanel }/>
            </Route>

            <Route path="*" component={NotFound}/>
        </Route>
    </div>
);